import React from 'react';
import ReactDOM from 'react-dom';
import { SubtitlesStyled } from './styles/PlayerSkinStyled';
import { StyledComponent } from 'styled-components';

export const SUBTITLES_CONTAINER_ID = 'mggpSubtitlesContainer';

const SubtitlesStyledCasted: StyledComponent<
  'div',
  any,
  { fullscreen: boolean },
  never
> = SubtitlesStyled;

interface IPropTypes {
  isFullscreen: boolean;
  subtitlePosition: number;
  subtitlesText: string | null;
}

export const Subtitles: React.FC<IPropTypes> = React.memo(
  ({ isFullscreen, subtitlePosition, subtitlesText }) => {
    const jsxElement = (
      <SubtitlesStyledCasted
        data-role="subtitles"
        fullscreen={isFullscreen}
        style={{ bottom: subtitlePosition }}
        dangerouslySetInnerHTML={
          subtitlesText ? { __html: subtitlesText } : undefined
        }
      />
    );

    const renderContainer = document.querySelector(
      `#${SUBTITLES_CONTAINER_ID}`
    );

    return renderContainer
      ? ReactDOM.createPortal(jsxElement, renderContainer)
      : jsxElement;
  }
);
Subtitles.displayName = 'Subtitles';
